import { Column, InputTextAreaField, Typography } from '@tempmee/react';

/**
 * Free-text notes the office leaves for the dental professional being confirmed.
 */
export const NotesForProfessional = ({ value, onChange }) => (
  <Column gap={2} py={5}>
    <Typography as="h2" size="body_large" weight="bold">
      Notes for Dental Professional:
    </Typography>
    <InputTextAreaField
      className="confirm-notes-field"
      placeholder="Check in at front desk"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      height={80}
    />
  </Column>
);
